import React from 'react'

import { Modal } from 'antd'
import get from 'lodash/get'

import ResubscribeForm from '../../../../components/payment/ResubscribeForm'
import { theme } from '../../../../theme'

const accentColor = get(theme, 'colors.accent')

const Resubscribe = props => {
  const modalShown = get(props, 'modalShown')
  const message = get(props, 'message')
  const closeModal = get(props, 'closeModal')
  const title = get(props, 'title')
  const closable = get(props, 'closable')
  const afterUpdate = get(props, 'afterUpdate')
  const clientName = get(props, 'clientName')
  const isAdmin = get(props, 'isAdmin')

  return (
    <Modal
      visible={modalShown}
      closable={false}
      footer={null}
      bodyStyle={{
        borderTop: `4px solid ${accentColor}`,
      }}
      onCancel={closable ? closeModal : null}
      destroyOnClose
      width={650}
    >
      <ResubscribeForm
        message={message}
        title={title}
        afterUpdate={afterUpdate}
        clientName={clientName}
        isAdmin={isAdmin}
      />
    </Modal>
  )
}

export default Resubscribe
